import React from 'react'
import {Icon} from '@chakra-ui/react'

const RefreshIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M12.0782 23.4932C6.08178 23.4932 1.2002 18.6116 1.2002 12.6096C1.2002 6.60752 6.08178 1.73157 12.0782 1.73157C15.22 1.73157 17.9507 2.89707 19.9664 5.10983C20.1748 5.34068 20.1579 5.69539 19.9327 5.90372C19.7018 6.11205 19.3471 6.09515 19.1388 5.86994C17.3427 3.89928 14.9047 2.86328 12.0838 2.86328C6.70113 2.85765 2.32628 7.2325 2.32628 12.6096C2.32628 17.9866 6.70113 22.3615 12.0782 22.3615C17.4553 22.3615 21.8301 17.9866 21.8301 12.6096C21.8301 12.2999 22.0835 12.0465 22.3932 12.0465C22.7028 12.0465 22.9562 12.2999 22.9562 12.6096C22.9562 18.606 18.0746 23.4876 12.0782 23.4876V23.4932Z"
                fill="currentColor"
            />
            <path
                d="M19.6568 6.10079C19.3584 6.10079 19.1107 5.86994 19.0938 5.5659L18.8573 1.19105C18.8404 0.881379 19.0769 0.616748 19.3866 0.599857C19.6906 0.577335 19.9609 0.819444 19.9778 1.12912L20.2142 5.50397C20.2311 5.81364 19.9946 6.07827 19.685 6.09516C19.6737 6.09516 19.6624 6.09516 19.6512 6.09516L19.6568 6.10079Z"
                fill="currentColor"
            />
            <path
                d="M15.3099 6.59066C15.0283 6.59066 14.7806 6.3767 14.7525 6.08955C14.7187 5.77988 14.9383 5.50399 15.2479 5.46457L19.5946 4.97473C19.9043 4.93531 20.1802 5.16053 20.2196 5.4702C20.259 5.77988 20.0338 6.05577 19.7241 6.09518L15.3774 6.58503C15.3774 6.58503 15.3324 6.58503 15.3155 6.58503L15.3099 6.59066Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default RefreshIcon
